const DAY_FIRST_LOCALE = "en-GB";

function toValidDate(value) {
  const parsed = value instanceof Date ? new Date(value.getTime()) : new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatDayFirstDate(value, options = {}) {
  const parsed = toValidDate(value);
  if (!parsed) return "";
  return parsed.toLocaleDateString(DAY_FIRST_LOCALE, options);
}

export function formatDayFirstDateTime(value, options = {}) {
  const parsed = toValidDate(value);
  if (!parsed) return "";
  return parsed.toLocaleString(DAY_FIRST_LOCALE, options);
}
